import { wrapFetch } from '../libs/fetch';
import type { Employment, Industry, Occupation, OccupationDetail, Special, Mag } from '../types/toppage';

export const getEmployments = async () => {
  return await wrapFetch<Employment[]>('/api/v1/toppage/employments');
};

export const getIndustries = async () => {
  return await wrapFetch<Industry[]>('/api/v1/toppage/industries');
};

export const getOccupations = async () => {
  return await wrapFetch<Occupation[]>('/api/v1/toppage/occupations');
};

export const getOccupationDetails = async () => {
  return await wrapFetch<OccupationDetail[]>('/api/v1/toppage/occupation_details');
};

export const getSpecials = async () => {
  return await wrapFetch<Special[]>('/api/v1/toppage/specials');
};

export const getMagcategories = async () => {
  return await wrapFetch<Mag[]>('/api/v1/toppage/mags');
}
